import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { WriteOffHistoryStateData } from './types';

const initialState: WriteOffHistoryStateData = {
	data: {
		data: {
			count: '',
			current_page: '',
			has_next_page: '',
			has_previous_page: '',
			message: null,
			items: [],
			num_pages: '',
		},
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchWriteOffHistory = createAsyncThunk(
	'api/fetchWriteOffHistory',
	({ sessionId, fromDate, toDate, page }: { sessionId: string; fromDate: string; toDate: string; page: number }) =>
		api.fetchWriteOffHistory(sessionId, fromDate, toDate, page),
);

const writeOffHistorySlice = createSlice({
	name: 'payHistory',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchWriteOffHistory.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchWriteOffHistory.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchWriteOffHistory.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузкe';
			});
	},
});

export default writeOffHistorySlice.reducer;
